<template>
    <div>
        <b-form class="followup-form mx-auto mt-40"
                @submit.stop.prevent="next">
            <div class="mb-1 mx-0">
                <div class="px-0 mb-3">
                    <div class="label text-center">請輸入你預約時寫的手機號碼</div>
                </div>
                <div class="input-width mx-auto">
                    <b-form-input :value="form.cellphone"
                                  @change.native="(e)=>{
                                        onChange(e.target.value, 'cellphone');
                                    }"
                                  :state="validateState('cellphone')"
                                  placeholder="請輸入行動電話，例：0987654321"
                                  autocomplete="off"
                                  maxLength="10"
                                  :disabled="!edit"></b-form-input>
                </div>
                <div class="input-width mx-auto">
                    <div class="error text-left"
                         v-if="$v.form.cellphone.$dirty&&!$v.form.cellphone.required">請輸入行動電話</div>
                    <div class="error text-left"
                         v-if="$v.form.cellphone.required&&$v.form.cellphone.$dirty&&!$v.form.cellphone.cellphonePattern">行動電話格式錯誤，請重新輸入</div>
                </div>
            </div>
            <div v-if="edit">
                <div class="d-flex flex-row justify-content-center align-items-center mt-40">
                    <b-button pill
                              type="submit"
                              variant="primary"
                              data-ga-element="新保險網站_查詢預約_下一步"
                              class="global-button">下一步</b-button>
                </div>
            </div>
        </b-form>
        <Otp :edit="edit"
             :editCallback="editCallback"
             :otpCallback="otpCallback"
             :cellphone="form.cellphone" />
    </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import Otp from './Otp.vue';
import moment from 'moment';
import { request } from '@/service';

/* 表單驗證 --- */
const cellphonePattern = (value) => {
    const pattern = /^09\d{8}$/;
    return pattern.test(value);
};

export default {
    mixins: [validationMixin],
    name: 'Content',
    components: {
        Otp,
    },
    computed: {
        hasContent: {
            get() {
                return this.$store.state.hasContent;
            },
            set(value) {
                this.value = value;
            }
        }
    },
    beforeRouteEnter(to, from, next) {
        if (from.name !== 'Result') {
            next();
        } else {
            next({ name: 'Home' });
        }
    },
    data() {
        return {
            edit: true,
            otpCodeUUID: null,
            form: {
                cellphone: '',
            }
        };
    },
    methods: {
        // 手機號碼填寫完成, 下一步: 進行otp
        next() {
            this.$v.form.$touch();
            if (this.$v.form.$anyError) {
                return;
            }
            this.edit = false;
        },
        onChange(value, name) {
            this.form[name] = value;
            this.$v.form[name].$touch();
        },
        validateState(name) {
            const { $dirty, $error } = this.$v.form[name];
            return $dirty ? !$error : null;
        },
        otpCallback(value) {
            this.otpCodeUUID = value;
            this.searchResults();
        },
        editCallback() {
            this.edit = true;
        },
        searchResults() {
            request({
                method: 'POST',
                api: '/api/getReserveInfoHistory',
                data: {
                    cellphone: this.form.cellphone,
                    otpCodeUUID: this.otpCodeUUID,
                }
            })
                .then(res => {
                    this.products = res.data.reserveInfoList;
                    this.products.map(item => {
                        item.reserveTimestamp = moment(item.reserveTimestamp).format('YYYY/MM/DD HH:mm');
                    });
                    sessionStorage.setItem('products', JSON.stringify(this.products));
                    if (this.$store.state.hasContent) {
                        this.$router.push({ name: 'Result' });
                    } else {
                        this.$router.push({ name: 'ResultForShare' });
                    }
                }).catch((e) => {
                    // error: edit error toast text
                    if (e.status === 500) {
                        this.$notify({
                            group: 'alert',
                            title: e.message,
                            type: 'error',
                        });
                    }
                });
        },
    },
    validations: {
        form: {
            cellphone: {
                required,
                cellphonePattern
            },
        }
    },
};
</script>
